// extracted by mini-css-extract-plugin
module.exports = {"loaderBackground":"#716AFC","loaderColor":"#fff","panelBackground":"#716AFC","panelColor":"#fff","buttonBackground":"#fff","buttonColor":"#716AFC"};